/* Ink & Oak — site fixes (Oct 21 2026): delivery estimator, personalization helpers, mobile buy bar. */
(function () {
  'use strict';
  /* IO-DELIVERY-CORE START (pure date/region logic; tested in node) */
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  // Days the studio does not ship (Canadian statutory holidays + Ontario Family Day / Civic Holiday), 2026–2027.
  // Remembrance Day (Nov 11) is intentionally NOT skipped.
  var HOLIDAYS = ['2026-12-25','2026-12-28','2027-01-01','2027-02-15','2027-03-26','2027-05-24','2027-07-01','2027-08-02','2027-09-06','2027-10-11','2027-12-27','2027-12-28'];
  var PRODUCTION_DAYS = 1;   // ships in 1 business day
  var CUTOFF_HOUR = 14;      // 2:00 PM Toronto time
  var TZ = 'America/Toronto';
  // Dates are plain calendar days held as UTC-midnight Date objects (no DST surprises).
  function day(y, m, d) { return new Date(Date.UTC(y, m, d)); }
  var XMAS = { ca: day(2026, 11, 8), us: day(2026, 11, 9), eve: day(2026, 11, 24), end: day(2026, 11, 25) };
  var DEFAULTS = {
    CA: { country: 'CA', label: 'across most of Canada', prefix: '', min: 3, max: 10, hint: 'Enter your postal code for your date' },
    US: { country: 'US', label: 'across most of the US', prefix: '', min: 5, max: 10, hint: 'Enter your ZIP code for your date' }
  };
  var INVALID_MSG = 'Please enter a Canadian postal code or US ZIP code.';

  function iso(d) { return d.getUTCFullYear() + '-' + String(d.getUTCMonth() + 1).padStart(2, '0') + '-' + String(d.getUTCDate()).padStart(2, '0'); }
  function isBusiness(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) === -1; }
  function addBusinessDays(from, n) { var d = new Date(from.getTime()); while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (isBusiness(d)) n--; } return d; }
  function fmt(d) { return DAYS[d.getUTCDay()] + ', ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate(); }

  // Current Toronto wall-clock time -> { date: UTC-midnight Date, hour: 0-23 }
  function torontoNow(now) {
    now = now || new Date();
    var p = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
        .formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
      return { date: day(+p.year, +p.month - 1, +p.day), hour: (+p.hour) % 24 };
    } catch (e) {
      return { date: day(now.getFullYear(), now.getMonth(), now.getDate()), hour: now.getHours() };
    }
  }

  // start = today if a business day before 2 PM, else next business day; ship = next business day after start.
  function shipDate(t) {
    var start = (isBusiness(t.date) && t.hour < CUTOFF_HOUR) ? t.date : addBusinessDays(t.date, 1);
    return addBusinessDays(start, PRODUCTION_DAYS);
  }

  var CA_LETTERS = 'ABCEGHJKLMNPRSTVXY';
  function lookupRegion(raw) {
    var s = String(raw || '').toUpperCase().replace(/[\s-]/g, '');
    if (!s) return null;
    if (/^[A-Z]\d[A-Z](\d[A-Z]\d)?$/.test(s) && CA_LETTERS.indexOf(s[0]) !== -1) {
      var L = s[0], rural = s[1] === '0', r;
      var R = function (label, min, max) { return { ok: true, country: 'CA', code: s.length === 6 ? s.slice(0, 3) + ' ' + s.slice(3) : s, label: label, prefix: 'to ', min: min, max: max }; };
      switch (L) {
        case 'M': return R('Toronto', 3, 5);
        case 'L': return rural ? R('Ontario', 4, 8) : R('the Greater Toronto Area', 3, 5);
        case 'K': return (s[1] === '1' || s[1] === '2') ? R('Ottawa', 3, 5) : R('Ontario', 4, 8);
        case 'N': return rural ? R('Ontario', 4, 8) : R('Southwest Ontario', 3, 5);
        case 'P': return R('Ontario', 4, 8);
        case 'H': return R('Montreal', 4, 8);
        case 'G': case 'J': return R('Quebec', 5, 10);
        case 'A': return R('Newfoundland and Labrador', 5, 10);
        case 'B': return R('Nova Scotia', 5, 10);
        case 'C': return R('Prince Edward Island', 5, 10);
        case 'R': return R('Manitoba', 5, 10);
        case 'S': return rural ? R('rural Saskatchewan', 7, 14) : R('Saskatchewan', 5, 10);
        case 'T': return rural ? R('rural Alberta', 7, 14) : R('Alberta', 5, 10);
        case 'V': return rural ? R('rural BC', 7, 14) : R('British Columbia', 5, 10);
        case 'E': return R('New Brunswick', 7, 14);
        case 'X': return R('Nunavut / Northwest Territories', 7, 14);
        case 'Y': return R('Yukon', 7, 14);
      }
    }
    if (/^\d{5}(\d{4})?$/.test(s)) {
      var p3 = parseInt(s.slice(0, 3), 10);
      var code = s.length === 9 ? s.slice(0, 5) + '-' + s.slice(5) : s;
      var remote = (p3 >= 995 && p3 <= 999) || (p3 >= 967 && p3 <= 969) || (p3 >= 6 && p3 <= 9);
      return remote
        ? { ok: true, country: 'US', code: code, label: 'Alaska, Hawaii & territories', prefix: 'to ', min: 7, max: 14 }
        : { ok: true, country: 'US', code: code, label: 'the US', prefix: 'to ', min: 5, max: 10 };
    }
    return { ok: false, msg: INVALID_MSG };
  }

  // Full estimate. code: entered/saved code ('' = none). country: Shopify localization ISO code.
  function estimate(code, country, now) {
    var t = torontoNow(now);
    var ship = shipDate(t);
    var region = code ? lookupRegion(code) : null;
    if (region && !region.ok) return { ok: false, msg: region.msg, ship: ship, shipText: fmt(ship) };
    var isDefault = !region;
    if (isDefault) region = country === 'US' ? DEFAULTS.US : DEFAULTS.CA;
    var min = addBusinessDays(ship, region.min), max = addBusinessDays(ship, region.max);
    var lateForXmas = t.date < XMAS.end && max > XMAS.eve;
    return {
      ok: true, isDefault: isDefault, region: region, ship: ship, min: min, max: max,
      shipText: fmt(ship),
      text: 'Estimated delivery: ' + fmt(min) + ' – ' + fmt(max) + ' ' + region.prefix + region.label,
      hint: isDefault ? region.hint : '',
      xmasWarn: lateForXmas
    };
  }
  /* IO-DELIVERY-CORE END */

  function xmasLine(short) {
    var t = torontoNow().date;
    if (t >= XMAS.end || t.getUTCMonth() < 9) return '';
    if (t <= XMAS.ca) return short ? 'Christmas: order by Dec 8' : 'For Christmas delivery, order by <strong>Tue, Dec 8</strong> (Canada) or <strong>Wed, Dec 9</strong> (US).';
    if (t <= XMAS.us) return short ? 'Christmas: US orders by Dec 9' : 'For Christmas: US orders by <strong>Wed, Dec 9</strong>. Canada: <a href="/pages/contact">email us</a> before ordering to check timing.';
    return short ? 'Christmas: email us to check timing' : 'Ordering for Christmas? <a href="/pages/contact">Email us first</a> and we\'ll tell you honestly if it can arrive in time.';
  }

  /* ---------- delivery estimator ---------- */
  var STORE_KEY = 'io_postal_code';
  function getSaved() { try { return window.localStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; } }
  function setSaved(v) { try { window.localStorage.setItem(STORE_KEY, v); } catch (e) {} }

  function paintEstimator(box, code) {
    var est = estimate(code, (box.getAttribute('data-country') || 'CA').toUpperCase());
    var out = box.querySelector('[data-io-est-text]');
    var hint = box.querySelector('[data-io-est-hint]');
    var warn = box.querySelector('[data-io-est-warn]');
    box.querySelectorAll('[data-io-ship]').forEach(function (el) { el.textContent = est.shipText; });
    if (!est.ok) {
      box.classList.add('io-est--error');
      if (out) out.textContent = est.msg;
      if (hint) hint.textContent = '';
      if (warn) warn.hidden = true;
      return false;
    }
    box.classList.remove('io-est--error');
    if (out) out.textContent = est.text;
    if (hint) hint.textContent = est.hint ? ' · ' + est.hint : '';
    if (warn) warn.hidden = !est.xmasWarn;
    return true;
  }

  function initEstimators() {
    var saved = getSaved();
    document.querySelectorAll('[data-io-est]').forEach(function (box) {
      var input = box.querySelector('[data-io-est-input]');
      var btn = box.querySelector('[data-io-est-btn]');
      if (input && saved && !input.value) input.value = saved;
      paintEstimator(box, saved);
      if (box.dataset.ioEstInit) return;
      box.dataset.ioEstInit = '1';
      var run = function () {
        var v = input ? input.value.trim() : '';
        if (!v) { paintEstimator(box, ''); return; }
        if (paintEstimator(box, v)) {
          var r = lookupRegion(v);
          if (r && r.ok) {
            input.value = r.code;
            setSaved(r.code);
            document.querySelectorAll('[data-io-est]').forEach(function (other) {
              if (other === box) return;
              var oi = other.querySelector('[data-io-est-input]');
              if (oi) oi.value = r.code;
              paintEstimator(other, r.code);
            });
          }
        }
      };
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); run(); });
      if (input) input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); e.stopPropagation(); run(); }
      });
    });
  }

  function renderDelivery() {
    var ship = estimate('', 'CA').shipText;
    document.querySelectorAll('[data-io-ship]').forEach(function (el) { el.textContent = ship; });
    document.querySelectorAll('[data-io-xmas]').forEach(function (el) {
      var html = xmasLine(false);
      if (html) { el.innerHTML = html; el.hidden = false; } else { el.hidden = true; }
    });
    document.querySelectorAll('[data-io-xmas-short]').forEach(function (el) {
      var txt = xmasLine(true);
      if (txt) { el.textContent = txt; } else { var li = el.closest('li'); if (li) li.hidden = true; }
    });
    initEstimators();
  }

  /* ---------- personalization helpers ---------- */
  function selectedOptionText(scope) {
    var root = (scope && scope.closest('product-info, .product')) || document;
    var vals = [];
    root.querySelectorAll('variant-selects input:checked, variant-selects select').forEach(function (el) { vals.push(String(el.value || '').toLowerCase()); });
    return vals;
  }
  function applyConditions() {
    document.querySelectorAll('.io-field[data-io-help]').forEach(function (wrap) {
      var m = /only if you cho(?:se|ose)\s+(?:a |an |the )?([^.;(]+)/i.exec(wrap.getAttribute('data-io-help') || '');
      if (!m) return;
      var key = m[1].trim().toLowerCase().replace(/s$/, '');
      var vals = selectedOptionText(wrap);
      if (!vals.length) return;
      var show = vals.some(function (v) { return v.indexOf(key) !== -1 && !/^no\b|\bonly$/.test(v); });
      wrap.hidden = !show;
      wrap.querySelectorAll('input, textarea, select').forEach(function (el) { el.disabled = !show; });
    });
  }
  function initCounters() {
    document.querySelectorAll('.io-field input[maxlength], .io-field textarea[maxlength]').forEach(function (el) {
      if (el.dataset.ioCounter) return;
      el.dataset.ioCounter = '1';
      var max = parseInt(el.getAttribute('maxlength'), 10);
      if (!max || max > 400) return;
      var c = document.createElement('span');
      c.className = 'io-count';
      c.setAttribute('aria-hidden', 'true');
      var upd = function () { c.textContent = el.value.length + ' / ' + max; c.classList.toggle('io-count--near', el.value.length >= max - 2); };
      el.addEventListener('input', upd);
      upd();
      el.insertAdjacentElement('afterend', c);
    });
    document.querySelectorAll('.io-field input, .io-field textarea, .io-field select').forEach(function (el) {
      if (el.dataset.ioClear) return;
      el.dataset.ioClear = '1';
      var clear = function () { el.setCustomValidity(''); var w = el.closest('.io-field'); if (w) { w.classList.remove('io-field--invalid'); var msg = w.querySelector('.io-error'); if (msg) msg.remove(); } };
      el.addEventListener('input', clear);
      el.addEventListener('change', clear);
    });
  }

  /* ---------- mobile buy bar ---------- */
  function initBuyBar() {
    var btn = document.querySelector('product-form [type="submit"][name="add"]');
    if (!btn || document.querySelector('.io-buybar')) return;
    var bar = document.createElement('div');
    bar.className = 'io-buybar';
    bar.innerHTML = '<span class="io-buybar__price"></span><button type="button" class="button io-buybar__btn">Personalize &amp; add to cart</button>';
    document.body.appendChild(bar);
    var priceEl = bar.querySelector('.io-buybar__price');
    var setPrice = function () {
      var p = document.querySelector('.product__info-container .price__sale .price-item--sale, .product__info-container .price__regular .price-item--regular');
      priceEl.textContent = p ? p.textContent.trim() : '';
    };
    bar.querySelector('button').addEventListener('click', function () {
      var target = null;
      document.querySelectorAll('.io-field [required]:not([disabled])').forEach(function (el) { if (!target && !String(el.value || '').trim()) target = el; });
      target = target || btn;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) {} }, 400);
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting;
        setPrice();
        bar.classList.toggle('io-buybar--show', past);
      }, { threshold: 0 });
      io.observe(btn);
    }
  }

  function init() {
    renderDelivery();
    initCounters();
    applyConditions();
    initBuyBar();
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(function () { applyConditions(); initCounters(); }, 60);
  });
  // Cart drawer / section re-renders: re-bind any new estimator markup.
  document.addEventListener('shopify:section:load', function () { renderDelivery(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.IOFixes = { renderDelivery: renderDelivery, applyConditions: applyConditions, estimate: estimate, lookupRegion: lookupRegion };
})()